import {throttled, fetch} from '~/lib/fetch';
import config from '~/configuration';

const user = {
  me: throttled(async () => {
    const response = await fetch(config.api, {
      method: 'POST',
      body: JSON.stringify({
        query: `
        query Query {
            me: me {
              user_id
              email
              first_name
              last_name
              user_settings
              lessors
            }
          }    
        `,
      }),
    });

    if (!response) {
      return null;
    }

    const {me} = await response.json();

    return me;
  }),
  logout: async () => {},
  metrics: async (summary) => {
    await fetch(config.api, {
      method: 'POST',
      body: JSON.stringify({
        query: `
        mutation Mutation($summary: Object!) {
            data:metrics(
              summary: $summary
            ) {
              success
            }
          } 
        `,
        variables: {
          summary,
        },
      }),
    });
  },
};

export default user;
